{
  "CustomNameLabel": "Nome:",
  "CustomWidthLabel": "Largura (0 - 100):",
  "CustomSettings_SectionHeader": "Configurações personalizadas",
  "NAME": "CustomSettings"
}